import { memo } from "react";
import { SearchOutlined, FilterOutlined } from "@ant-design/icons";
import { Badge, Button, Card, DatePicker, Input, Popover, Select } from "antd";
import filterIcon from "../../assets/filter.png"
import { InputAdornment, TextField } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";


function SearchAndFilterComponent({
  activeTab,
  statusFilter,
  setFilterData,
  invoiceStartDate,
  milestoneStatusFilter,
  setRevenueMonthFilter,
  setInvoiceStartDate,
  setInvoiceEndDate,
  filterOpen,
  setFilterOpen,
  filterLoading,
  handleApplyFilters,
  handleClearFilters,
  search,
  setSearch,
  activeFilterCount,
  setMilestoneStatusFilter,
  milestoneStartDate,
  setMilestoneStartDate,
  milestoneEndDate,
  setMilestoneEndDate,
  setStatusFilter,
}) {

  const trimmedSearchLength = search.trim().length;
  const showSearchError = trimmedSearchLength > 0 && trimmedSearchLength < 3;
  const filterContent = (
  <div
    style={{
      width: 320,
      padding: 4,
      maxHeight: "70vh",
      overflowY: "auto",
    }}
  >
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 16,
      }}
    >
      <span style={{ fontWeight: 600, fontSize: 14 }}>
        Filters
      </span>

      {activeFilterCount > 0 && (
        <Button
          type="link"
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            handleClearFilters();
          }}
          style={{ padding: 0, fontSize: 12 }}
        >
          Clear all
        </Button>
      )}
    </div>

    {activeTab === "milestones" && (
      <>
        <div style={{ marginBottom: 16 }}>
          <div
            style={{
              fontSize: 12,
              color: "#595959",
              fontWeight: 600,
              marginBottom: 6,
            }}
          >
            Milestone Status
          </div>

          <Select
            size="middle"
            value={milestoneStatusFilter}
            onChange={setMilestoneStatusFilter}
            style={{ width: "100%" }}
            options={[
              { value: "all", label: "All Status" },
              { value: "Not Submitted", label: "Not Submitted" },
              { value: "Submitted", label: "Submitted" },
              { value: "Paid", label: "Paid" },
            ]}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <div
            style={{
              fontSize: 12,
              color: "#595959",
              fontWeight: 600,
              marginBottom: 8,
            }}
          >
            Milestone Date Range
          </div>

          <div style={{ display: "flex", gap: 8 }}>
            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: 11,
                  color: "#8c8c8c",
                  marginBottom: 4,
                }}
              >
                From
              </div>

              <DatePicker
                picker="month"
                style={{ width: "100%" }}
                format="MMM YYYY"
                placeholder="From Month"
                value={milestoneStartDate}
                popupClassName="milestone-month-picker-popup"
                disabledDate={(current) =>
                  milestoneEndDate
                    ? current.isAfter(milestoneEndDate, "month")
                    : false
                }
                onChange={(date) => {
                  setMilestoneStartDate(date);
                }}
                allowClear
              />
            </div>

            <div style={{ flex: 1 }}>
              <div
                style={{
                  fontSize: 11,
                  color: "#8c8c8c",
                  marginBottom: 4,
                }}
              >
                To
              </div>

              <DatePicker
                picker="month"
                style={{ width: "100%" }}
                format="MMM YYYY"
                placeholder="To Month"
                value={milestoneEndDate}
                popupClassName="milestone-month-picker-popup"
                disabledDate={(current) =>
                  milestoneStartDate
                    ? current.isBefore(milestoneStartDate, "month")
                    : false
                }
                onChange={(date) => {
                  setMilestoneEndDate(date);
                }}
                allowClear
              />
            </div>
          </div>
        </div>
      </>
    )}

    {activeTab === "invoices" && (
      <>
        <div style={{ marginBottom: 16 }}>
          <div
            style={{
              fontSize: 12,
              color: "#595959",
              fontWeight: 600,
              marginBottom: 6,
            }}
          >
            Fieldglass Status
          </div>

          <Select
            size="middle"
            value={statusFilter}
            onChange={setStatusFilter}
            style={{ width: "100%" }}
            options={[
              { value: "all", label: "All Status" },
              { value: "Invoiced", label: "Invoiced" },
              { value: "Pending Approval", label: "Pending Approval" },
              { value: "Rejected", label: "Rejected" },
            ]}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <div
            style={{
              fontSize: 12,
              color: "#595959",
              fontWeight: 600,
              marginBottom: 6,
            }}
          >
            Revenue Month
          </div>

          <DatePicker
            picker="month"
            style={{ width: "100%" }}
            format="MMM YYYY"
            placeholder="Select Month"
            value={invoiceStartDate}
            popupClassName="milestone-month-picker-popup"
            onChange={(date) => {
              setInvoiceStartDate(date);
              setInvoiceEndDate(null);
            }}
            allowClear
          />
        </div>
      </>
    )}

    <Button
      type="primary"
      block
      loading={filterLoading}
      onClick={(e) => {
        e.stopPropagation();
        handleApplyFilters();
      }}
      style={{
        marginTop: 8,
        borderRadius: 8,
      }}
    >
      Apply Filters
    </Button>
  </div>
);

  return (
    <>
      <style>{`
          .milestone-month-picker-popup .ant-picker-cell:hover:not(.ant-picker-cell-selected) .ant-picker-cell-inner {
            background: #1677ff !important;
            color: #fff !important;
          }

          /* Keep dropdown option text and calendar panel text the same
             12px as the rest of the filter fields. These render in a
             portal, so inline style on the Select/DatePicker can't reach
             them - this reuses the existing popup class instead. */
          .milestone-month-picker-popup .ant-select-item,
          .milestone-month-picker-popup .ant-select-item-option-content {
            font-size: 12px !important;
          }

          .milestone-month-picker-popup.ant-picker-dropdown .ant-picker-header,
          .milestone-month-picker-popup.ant-picker-dropdown .ant-picker-header-view,
          .milestone-month-picker-popup.ant-picker-dropdown .ant-picker-header button,
          .milestone-month-picker-popup.ant-picker-dropdown .ant-picker-cell,
          .milestone-month-picker-popup.ant-picker-dropdown .ant-picker-content {
            font-size: 12px !important;
          }

          /* Select field text and DatePicker input text inside the filter
             popover (these aren't portaled, but antd sets an explicit
             font-size on these inner elements that a plain inline style
             on the wrapping Select/DatePicker won't override). */
          .sf-filter-popup-content .ant-select-selector,
          .sf-filter-popup-content .ant-select-selection-item,
          .sf-filter-popup-content .ant-select-selection-placeholder,
          .sf-filter-popup-content .ant-select-selection-search-input,
          .sf-filter-popup-content .ant-picker-input > input {
            font-size: 12px !important;
          }
        `}</style>

      <div style={{ display: "flex", gap: 12, alignItems: "flex-start",marginBottom:12 }}>
        <div style={{ flex: 1 }}>
          <TextField
            size="small"
            fullWidth
            placeholder={
              activeTab === "milestones"
                ? "Search by SOW ID, Project ID, Milestone Name , Account name..."
                : "Search by Project ID, Invoice Id ..."
            }
            value={search}
            error={showSearchError}
            onChange={(e) => setSearch(e.target.value)}
            slotProps={{
              input: {
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon
                      sx={{
                        fontSize: 17,
                        color: "#64748b",
                      }}
                    />
                  </InputAdornment>
                ),
              },
            }}
            sx={{
              width: "100%",
              "& .MuiOutlinedInput-root": {
                height: 40,
                borderRadius: "4px",
                fontSize: 13,
              },
            }}
          />

          <div style={{ minHeight: 18, marginTop: 4 }}>
          {showSearchError && (
            <div style={{ color: "#ff0000", fontSize: 12 }}>
              Minimum 3 characters required to search.
            </div>
          )}
        </div>
        </div>
        <Popover
          content={
            <div className="sf-filter-popup-content" style={{ width: 300, padding: "4px 0" }}>
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
                <span style={{ fontWeight: 600, fontSize: 14 }}>Filters</span>
                {activeFilterCount > 0 && (
                  <Button
                    type="link"
                    size="small"
                    
                    onClick={() => {
                      handleClearFilters();
                    }}
                    style={{ padding: 0, fontSize: 12 }}
                  >
                    Clear all
                  </Button>
                )}
              </div>

              {activeTab === "milestones" && (
                <>
                  <div style={{ marginBottom: 14 }}>
                    <div style={{ fontSize: 12, color: "#595959", fontWeight: 600, marginBottom: 6 }}>Milestone Status</div>
                    <Select
                      size="middle"
                      value={milestoneStatusFilter}
                      onChange={(e) => setMilestoneStatusFilter(e)}
                      style={{ width: "100%", fontSize: 12 }}
                      popupClassName="milestone-month-picker-popup"
                      options={[
                        { value: "all", label: "All Status" },
                        { value: "Not Submitted", label: "Not Submitted" },
                        { value: "Submitted", label: "Submitted" },
                        { value: "Paid", label: "Paid" },
                      ]}
                    />
                  </div>

                  <div style={{ marginBottom: 14 }}>
                    <div style={{ fontSize: 12, color: "#595959", fontWeight: 600, marginBottom: 6 }}>
                      Milestone Date Range
                    </div>
                    <div style={{ display: "flex", gap: 8 }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 4 }}>From</div>
                        <DatePicker
                          picker="month"
                          style={{ width: "100%", fontSize: 12 }}
                          format="MMM YYYY"
                          placeholder="From Month"
                          value={milestoneStartDate}
                          popupClassName="milestone-month-picker-popup"
                          disabledDate={(current) =>
                            milestoneEndDate ? current.isAfter(milestoneEndDate, "month") : false
                          }
                          onChange={(date) => {
                            setMilestoneStartDate(date);
                            setFilterData([{
                              dateRange: date && milestoneEndDate ? [date, milestoneEndDate] : undefined,
                            }]);
                          }}
                          allowClear
                        />
                      </div>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 12, color: "#8c8c8c", marginBottom: 4 }}>To</div>
                        <DatePicker
                          picker="month"
                          style={{ width: "100%", fontSize: 12 }}
                          format="MMM YYYY"
                          placeholder="To Month"
                          value={milestoneEndDate}
                          popupClassName="milestone-month-picker-popup"
                          disabledDate={(current) =>
                            milestoneStartDate ? current.isBefore(milestoneStartDate, "month") : false
                          }
                          onChange={(date) => {
                            setMilestoneEndDate(date);
                            setFilterData([{
                              dateRange: milestoneStartDate && date ? [milestoneStartDate, date] : undefined,
                            }]);
                          }}
                          allowClear
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}

              {activeTab === "invoices" && (
                <>
                  <div style={{ marginBottom: 14 }}>
                    <div style={{ fontSize: 12, color: "#595959", fontWeight: 600, marginBottom: 6 }}>Fieldglass Status</div>
                    <Select
                      size="middle"
                      value={statusFilter}
                      onChange={(e) => setStatusFilter(e)}
                      style={{ width: "100%", fontSize: 12 }}
                      popupClassName="milestone-month-picker-popup"
                      options={[
                        { value: "all", label: "All Status" },
                        { value: "Invoiced", label: "Invoiced" },
                        { value: "Pending Approval", label: "Pending Approval" },
                        { value: "Rejected", label: "Rejected" },
                      ]}
                    />
                  </div>

                  <div style={{ marginBottom: 14 }}>
                    <div style={{ fontSize: 12, color: "#595959", fontWeight: 600, marginBottom: 6 }}>Revenue Month</div>
                    <DatePicker
                      picker="month"
                      style={{ width: "100%", fontSize: 12 }}
                      format="MMM YYYY"
                      placeholder="Select Month"
                      value={invoiceStartDate}
                      popupClassName="milestone-month-picker-popup"
                      onChange={(date) => {
                        setInvoiceStartDate(date);
                        setInvoiceEndDate(null);
                      }}
                      allowClear
                    />
                  </div>
                </>
              )}

              <Button
                type="primary"
                block
                loading={filterLoading}
                onClick={handleApplyFilters}
                style={{ marginTop: 4, borderRadius: 8, fontSize: 12 }}
              >
                Apply Filters
              </Button>

            </div>
          }
          trigger="click"
          open={filterOpen}
          onOpenChange={setFilterOpen}
        >
          <Badge
            count={activeFilterCount}
            size="small"
            offset={[-4, 4]}
          >
            <Button
              size="large"
              icon={
                <img
                  src={filterIcon}
                  alt="Filter"
                  style={{ width: 16, height: 16 }}
                />
              }
              loading={filterLoading}
              style={{
                height: 40,
                borderRadius: "4px",
                borderColor: activeFilterCount > 0 ? "#1677ff" : undefined,
                color: activeFilterCount > 0 ? "#1677ff" : undefined,
                fontWeight: activeFilterCount > 0 ? 600 : undefined,
                whiteSpace: "nowrap",
              }}
            >
              <img src="" alt="" />
              Filters
            </Button>
          </Badge>
        </Popover>
      </div>
    </>
  )
}

export const SearchAndFilter = memo(SearchAndFilterComponent);